import router from "../router";

export function toPage(url) {
    if (url) {
        router.push(url).then(() => {
            /*   window.scrollTo({
                   top: 0,
                   behavior: 'smooth'
               });*/
        });
    }
}

// 案例 / 文章
export function docHtmlPath(item) {
    if (item) {
        router.push({
            path: '/news_information_detail',
            query: {
                fileName: item.fileName,
                title: item.title,
                date: item.date,
                source: item.source,
            }
        })
    }
}

export const sortCaseByDate = (list) => {
    const arr = JSON.parse(JSON.stringify(list))
    return arr.sort((a, b) => new Date(b.date) - new Date(a.date))
}

export async function downloadDoc(file) {
    if (!file) {
        console.error('没有参数')
        return
    }
    // 创建a标签
    const link = document.createElement('a');
    document.body.appendChild(link);
    link.href = `/wpsDocment/${file}.pdf`;
    link.download = file + '.pdf';
    link.click();
    if (document.body.contains(link)) {
        document.body.removeChild(link);
    }
}